import './modal-rate-quote'
import * as d3 from 'd3';
import { add as addDate, format as formatDate } from 'date-fns'

import {
  cleanNumberRegex,
  currencyFormat,
  calculateMonthlyPayment,
  formatCalculatorValue,
  updateFormattedInputSelection,
} from './utils'

export default (function() {

  let dataGroups = [];

  /* eslint-disable no-unused-vars */
  var amortCalc = document.querySelector('.js-amortization-calculator');
  var submit = document.querySelector('.js-btn-calculate')
  function init() {
    if (!amortCalc) {
      return;
    }

    const handleInputMouseUp = (event) => {
      event.target.removeEventListener('mouseup', handleInputMouseUp)
      event.target.removeEventListener('keyup', handleInputMouseUp)
      updateFormattedInputSelection(event.target)
    }

    // submit.addEventListener('click', function() {
    //   runCalculation()
    // });

    var inputs = document.querySelectorAll('input[type="text"],input[type="date"]');
    inputs.forEach(function(input) {

      input.addEventListener('input', function() {
        runCalculation()
      });

      input.addEventListener('blur', function(event) {

        runCalculation()

        let format = event.target.dataset.format
        if (!format) {
          return;
        }

        let formattedValue = formatCalculatorValue(event.target.value, format)
        event.target.value = formattedValue
      });

      // On focus, switch to using just numeric value
      input.addEventListener('focus', (event) => {

        event.target.addEventListener('mouseup', handleInputMouseUp)
        event.target.addEventListener('keyup', handleInputMouseUp)
      })
    });

    function runCalculation() {

      var balance = parseFloat(document.querySelector('.loan-amount').value.replace(cleanNumberRegex, ''));
      var terms = parseFloat(document.querySelector('.mortgage-term').value);
      var termsAsMonths = terms * 12
      var interestRate = parseFloat(document.querySelector('.interest-rate').value.replace(cleanNumberRegex, '') / 100);
      var datePicked = document.querySelector('.start-date').value;
      var start = addDate(new Date(`${datePicked}`), { hours: 12, })

      var results = amort(balance, interestRate, termsAsMonths, start);
      renderResults(results)
    }

    runCalculation()

    /**
     * Amort function:
     * Calculates the necessary elements of the loan using the supplied user input
     * and then displays each months updated amortization schedule on the page
     */
    function amort(balance, interestRate, terms, start) {

      //Calculate the per month interest rate
      var monthlyInterestRate = interestRate / 12;

      var payment = calculateMonthlyPayment(balance, monthlyInterestRate, terms)

      document.querySelector('.results-payment').innerHTML = currencyFormat.format(payment)

      var rows = [];
      var loanStart = loanStart = addDate(start, { months: 1, })

      var totalInterestPaid = 0;
      var totalPrincipalPaid = 0;
      var entries = []

      var annualEntries = {}

      /**
       * Loop that calculates the monthly Loan amortization amounts then adds
       * them to the return string
       */
      for (var count = 0; count < terms; ++count) {
        //calc the in-loop interest amount and display
        var interest = balance * monthlyInterestRate;
        var monthlyPrincipal = payment - interest;

        totalInterestPaid += interest
        totalPrincipalPaid += monthlyPrincipal

        balance -= monthlyPrincipal

        let year = formatDate(loanStart, 'yyyy')
        let month = formatDate(loanStart, 'MMM')

        entries.push({
          year: year,
          month: month,
          interest: parseFloat(interest.toFixed(3)),
          principal: monthlyPrincipal,
          balance: balance,
        })

        if (count < (terms - 1)) {
          loanStart = addDate(loanStart, { months: 1, })
        }
      }

      entries.forEach((entry) => {
        if (!annualEntries[entry.year]) {
          return annualEntries[entry.year] = {
            year: entry.year,
            interest: entry.interest,
            principal: entry.principal,
          }
        }

        annualEntries[entry.year].interest += entry.interest
        annualEntries[entry.year].principal += entry.principal
        annualEntries[entry.year].balance = entry.balance
      })


      return {
        totalInterestPaid,
        totalPrincipalPaid,
        payOffDate: loanStart,
        monthlyBreakdown: entries,
        annualBreakdown: Object.values(annualEntries)
      }
    }

    function renderResults(results) {

      var scheduleEntries = results.monthlyBreakdown.map((entry) => {
        return `
        <tr>
          <td>${ entry.month } ${ entry.year }</td>
          <td>${ currencyFormat.format(entry.interest) }</td>
          <td>${ currencyFormat.format(entry.principal) }</td>
          <td>${ currencyFormat.format(entry.balance) }</td>
        </tr>
        `
      })

      var paymentSchedule = document.getElementById('payment-schedule');
      paymentSchedule.innerHTML = `
        <div class="table-results">
        <table border="1">
          <thead>
            <tr>
              <th>Month</th>
              <th>Interest</th>
              <th>Principal</th>
              <th>Balance</th>
            </tr>
          </thead>
          ${ scheduleEntries.join("\n") }
        </table>
      </div>`

      document.querySelector('.results-payoff-date').innerHTML = `${ formatDate(results.payOffDate, 'MM/dd/yyyy') }`
      document.querySelector('.results-total-interest-paid').innerHTML = currencyFormat.format(results.totalInterestPaid)
      document.querySelector('.results-total-principal-paid').innerHTML = currencyFormat.format(results.totalPrincipalPaid)

      dataGroups = getDataGroups(results.annualBreakdown)

      updateChart(dataGroups)
    }

    function getDataGroups(data) {

      // The amount of bars to keep across the graph
      let barCount = 10;

      if (data.length < barCount) {
        barCount = data.length
      }

      const yearsPerGroup = Math.floor(data.length / barCount)

      if (yearsPerGroup < 1) {
        yearsPerGroup = 1
      }

      let dataGroups = []

      while (data.length) {
        let group = data.splice(0, yearsPerGroup)
        dataGroups.push(
          group.reduce((map, obj) => {
            if (typeof map.year === 'undefined') {
              map.year = obj.year
            }

            if (typeof map.principal === 'undefined') {
              map.principal = 0
            }

            if (typeof map.interest === 'undefined') {
              map.interest = 0
            }

            if (typeof map.balance === 'undefined') {
              map.balance = obj.balance
            }

            map.principal += obj.principal
            map.interest += obj.interest

            return map
          }, {})
        )
      }
      console.log(dataGroups)
      return dataGroups
    }

    function updateChart(dataGroups) {

      const duration = 0

      let keys = ['principal', 'interest']
      let chartWrapper = d3.select(".amortization-chart")
      let charWrapperRect = chartWrapper.node().getBoundingClientRect()

      let margin = {top: 0, left: 0, bottom: 30, right: 0}
      // Maintain a 1:1 spect ratio
      let width = 400 - margin.left - margin.right
      let height = 400 - margin.top - margin.bottom

      if (window.innerWidth >= 680 && window.innerWidth < 900) {
        width = charWrapperRect.width
      }

      chartWrapper.selectAll('svg').remove()

      let graphSvg = chartWrapper.append('svg')
          .attr("width", width)
          .attr("height", height)
          .attr("viewBox", [0, 0, width, height])
          .attr('preserveAspectRatio', `xMidYMid meet`)
          .attr("class", "principal-interest-graph")

      let xScale = d3.scaleBand()
        .range([margin.left, width - margin.right])
        .padding(0.1)
        .domain(dataGroups.map(d => d.year));

      let barYScale = d3.scaleLinear()
        .rangeRound([height - margin.bottom, margin.top])
        .domain([0, d3.max(dataGroups, d => d3.sum(keys, k => +d[k]))]).nice()

      let lineYScale = d3.scaleLinear()
        .rangeRound([height - margin.bottom, margin.top])
        .domain([0, d3.max(dataGroups, function(d) {return Math.max(d.balance);})]);

      let zScale = d3.scaleOrdinal()
          .range(["#138058", "#004C3A"])
          .domain(keys);

      let graphXAxis = graphSvg.append("g")
          .attr("transform", `translate(0, ${height - margin.bottom})`)
          .attr("class", "x-axis")

      // let graphYAxis = graphSvg.append("g")
      //     .attr("transform", `translate(${margin.left},0)`)
      //     .attr("class", "y-axis")

      // dataGroups.forEach(function(d) {
      //   d.total = d3.sum(keys, k => +d[k])
      //   return d
      // })

      // Put back if we end up needing to draw ticks
      // graphSvg.selectAll(".y-axis")
      //   .transition()
      //   .duration(duration)
      //   .call(d3.axisLeft(barYScale).ticks(null, "s"))

      graphSvg.selectAll(".x-axis")
        .transition()
        .duration(duration)
        .call(d3.axisBottom(xScale).tickSizeOuter(0))

      var group = graphSvg.selectAll("g.layer")
        .data(d3.stack().keys(keys)(dataGroups), d => d.key)

      group.exit().remove()

      group.enter().append("g")
        .classed("layer", true)
        .attr("fill", d => zScale(d.key));

      var bars = graphSvg.selectAll("g.layer").selectAll("rect")
        .data(d => d, e => e.data.year);

      bars.exit().remove()

      bars.enter().append("rect")
        .attr("width", xScale.bandwidth())
        .merge(bars)
        .transition()
        .duration(duration)
        .attr("x", d => xScale(d.data.year))
        .attr("y", d => barYScale(d[1]))
        .attr("height", d => barYScale(d[0]) - barYScale(d[1]))

      var text = graphSvg.selectAll(".text")
        .data(dataGroups, (d) => d.year);

      text.exit().remove()

      let balanceGroup = graphSvg.append("g")
          .attr("transform", `translate(${ xScale.bandwidth() / 2 }, 0)`)
          .attr("class", "balance")

      // define the 1st line
      let balanceLine = d3.line()
        .x(function(d) { return xScale(d.year); })
        .y(function(d) { return lineYScale(d.balance); });

      // Add the valueline2 path.
      balanceGroup.append("path")
        .data([dataGroups])
        .attr("class", "line")
        .style("stroke", "#DEFF67")
        .style("stroke-width", "3")
        .style('fill', 'none')
        .attr("d", balanceLine);

      // Add the line
      balanceGroup.selectAll("points")
        .data(dataGroups)
        .enter()
        .append("circle")
          .attr("fill", "#DEFF67")
          .attr("stroke", "none")
          .attr("cx", function(d) { return xScale(d.year) })
          .attr("cy", function(d) { return lineYScale(d.balance) })
          .attr("r", 6)

    }

    let resizeTimeout;
    window.addEventListener('resize', () => {

      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }

      resizeTimeout = setTimeout(() => {
        updateChart(dataGroups)
      }, 250)
    })
  }

  return {
    init: init,
  }

  /* eslint-enable no-unused-vars */

})()
